import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { isAnchorSupported } from '../pm-plugins/utils/anchor';
// TODO: ED-23976 - Clean up
import { createTableView } from './table';
import TableCell from './TableCell';
import TableRow from './TableRow';
import TableRowNativeStickyWithFallback from './TableRowNativeStickyWithFallback';
export var tableView = function tableView(options) {
  return function (node, view, getPos) {
    return createTableView(node, view, getPos, options.portalProviderAPI, options.eventDispatcher, options.getEditorContainerWidth, options.getEditorFeatureFlags, options.dispatchAnalyticsEvent, options.pluginInjectionApi, options.isCommentEditor, options.isChromelessEditor);
  };
};
export var tableCellView = function tableCellView(options) {
  return function (node, view, getPos) {
    var _options$pluginInject;
    return new TableCell(node, view, getPos, options.eventDispatcher, (_options$pluginInject = options.pluginInjectionApi) === null || _options$pluginInject === void 0 || (_options$pluginInject = _options$pluginInject.analytics) === null || _options$pluginInject === void 0 ? void 0 : _options$pluginInject.actions);
  };
};
export var tableHeaderView = function tableHeaderView(options) {
  return function (node, view, getPos) {
    var _options$pluginInject2;
    return new TableCell(node, view, getPos, options.eventDispatcher, (_options$pluginInject2 = options.pluginInjectionApi) === null || _options$pluginInject2 === void 0 || (_options$pluginInject2 = _options$pluginInject2.analytics) === null || _options$pluginInject2 === void 0 ? void 0 : _options$pluginInject2.actions);
  };
};
export var tableRowView = function tableRowView(options) {
  return function (node, view, getPos) {
    if (isAnchorSupported() && expValEquals('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) {
      return new TableRowNativeStickyWithFallback(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi);
    } else {
      return new TableRow(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi);
    }
  };
};